export const DEFAULT_DEMO_NOTES = [
  "- Please call parents before going",
  "- Start with the introduction of yourself and build rapport with student",
  "- Teach the relevant subject(s)",
  "- Don't Say NO to any academic Request",
  "- Don't discuss the fees / any commercial discussion",
  "- After teaching ask them to contact Edushala Team.",
].join("\n");
